export const generateErrorObject = (error) => {
    const responseData = error?.response?.data
    const data = typeof responseData === 'object' && responseData !== null ? responseData : {}

    return {
        status: data.status || error?.status || 'error',
        statusCode: data.statusCode || error?.statusCode || error?.response?.status,
        message: data.message || (typeof responseData === 'string' ? responseData : error?.message),
    }
}
